import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import API from "../../../services/api";
import "./inventory-category.css";

export default function InventoryCategoryList() {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));

  const [categories,      setCategories]      = useState([]);
  const [items,           setItems]           = useState([]);
  const [activeCategory,  setActiveCategory]  = useState(null);
  const [activeName,      setActiveName]      = useState("");
  const [loading,         setLoading]         = useState(false);

  const loadCategories = async () => {
    try {
      const res = await API.get("/school-admin/inventory/categories/", {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      setCategories(res.data.categories || []);
    } catch (err) { console.error(err); }
  };

  useEffect(() => { loadCategories(); }, []);

  const loadItems = async (id, name) => {
    if (activeCategory === id) { setActiveCategory(null); setItems([]); return; }
    try {
      setLoading(true);
      setActiveCategory(id);
      setActiveName(name);
      const res = await API.get(`/school-admin/inventory/items/?category=${id}`, {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      setItems(res.data.items || []);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  const deleteCategory = async (e, id) => {
    e.stopPropagation();
    if (!window.confirm("Delete this category?")) return;
    try {
      await API.delete(`/school-admin/inventory/categories/${id}/`, {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      loadCategories();
      if (id === activeCategory) { setItems([]); setActiveCategory(null); }
    } catch (err) { console.error(err); }
  };

  return (
    <div className="ic-page">

      {/* ══ HERO ══ */}
      <div className="ic-hero">
        <div className="ic-hero-left">
          <div className="ic-hero-icon">🗂</div>
          <div>
            <h2 className="ic-hero-title">Inventory Categories</h2>
            <p className="ic-hero-sub">Organise items by category — {categories.length} total</p>
          </div>
        </div>
        <div className="ic-hero-right">
          <Link to="/school-admin/inventory/categories/add" className="ic-btn-add">+ Add Category</Link>
        </div>
      </div>

      {/* ══ CATEGORIES TABLE ══ */}
      <div className="ic-card">
        {categories.length === 0 ? (
          <div className="ic-empty">
            <div className="ic-empty-icon">📂</div>
            <strong>No categories yet</strong>
            <p>Create a category to organise your inventory</p>
          </div>
        ) : (
          <table className="ic-table">
            <thead>
              <tr>
                <th>Category Name</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {categories.map(c => (
                <tr
                  key={c.id}
                  className={activeCategory === c.id ? "active" : ""}
                  onClick={() => loadItems(c.id, c.name)}
                >
                  <td>
                    {activeCategory === c.id && <span className="ic-active-dot" />}
                    <span className="ic-cat-name">{c.name}</span>
                  </td>
                  <td>
                    <button className="ic-btn-del" onClick={e => deleteCategory(e, c.id)}>
                      🗑 Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* ══ ITEMS PANEL ══ */}
      {activeCategory && (
        <div className="ic-items-panel">
          <div className="ic-items-panel-head">
            <span className="ic-items-panel-title">
              📦 Items in "{activeName}" — {items.length}
            </span>
          </div>
          {loading ? (
            <p style={{ color:"#94a3b8", fontSize:"13px" }}>Loading items…</p>
          ) : items.length === 0 ? (
            <p style={{ color:"#94a3b8", fontSize:"13px" }}>No items in this category.</p>
          ) : (
            <table className="ic-inner-table">
              <thead>
                <tr>
                  <th>Item Name</th>
                  <th>Qty</th>
                  <th>Price (₹)</th>
                  <th>Vendor</th>
                  <th>Purchase Date</th>
                </tr>
              </thead>
              <tbody>
                {items.map(i => (
                  <tr key={i.id}>
                    <td style={{ fontWeight:700 }}>{i.name}</td>
                    <td>{i.quantity}</td>
                    <td>₹ {Number(i.purchase_price || 0).toLocaleString()}</td>
                    <td>{i.vendor || "—"}</td>
                    <td>{i.purchase_date || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

    </div>
  );
}
